/* eslint-disable import/order */
/* eslint-disable react-hooks/exhaustive-deps */
import IconInfo from '@/assets/icons/info-icon.svg';
import { useGetPackageSizeDefinitions } from '@/features/booking/api/master-data/use-get-package-size-definitions';

import {
  Box,
  Button,
  Card,
  em,
  Group,
  Image,
  rem,
  SimpleGrid,
  Text,
  Title,
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import type { ContextModalProps } from '@mantine/modals';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Mousewheel } from 'swiper/modules';
import { Swiper, type SwiperClass, SwiperSlide, useSwiper } from 'swiper/react';

const BikePackageSizeDefinitionModal = ({ context }: ContextModalProps) => {
  const isMobile = useMediaQuery(`(max-width: ${em(767)})`);
  const tCommon = useTranslations('common');
  const swiper = useSwiper();
  const { data: sizeDefinitionList = [] } = useGetPackageSizeDefinitions();

  const [activeIndex, setActiveIndex] = useState<number>(0);
  const handleClose = () => {
    context.closeAll();
  };

  const handleSlideChange = (swiper: SwiperClass) => {
    setActiveIndex(swiper.realIndex);
  };

  useEffect(() => {
    swiper?.slideTo(activeIndex);
  }, [activeIndex]);

  const SwiperNavigation = () => {
    const swiper = useSwiper();

    return (
      <Group my={16} gap={8}>
        {sizeDefinitionList?.map(({ size }, i) => (
          <Button
            key={i}
            variant={activeIndex === i ? 'filled' : 'outline'}
            c={activeIndex === i ? 'primary' : 'neutral.7'}
            onClick={() => {
              swiper?.slideTo(i);
            }}
            style={{
              width: rem(40),
              height: rem(40),
              borderRadius: '50%',
              borderColor:
                activeIndex === i
                  ? 'var(--mantine-color-primary-6)'
                  : 'var(--mantine-color-neutral-4)',
              backgroundColor:
                activeIndex === i
                  ? 'var(--mantine-color-primary-2)'
                  : 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Text
              fw={activeIndex === i ? 600 : 500}
              size={isMobile ? 'sm' : 'md'}
            >
              {size}
            </Text>
          </Button>
        ))}
      </Group>
    );
  };

  return (
    <Box
      style={{
        minHeight: isMobile ? 'calc(100vh - 45px)' : '620px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Card
        px={isMobile ? rem(16) : rem(24)}
        py={rem(16)}
        mb={isMobile ? 0 : rem(12)}
        c="neutral.6"
        bg="linear-gradient(180deg, var(--brand-orange-orange-00-bg-1, #FFF7F2) -6.4%, var(--base-white-black-white, #FFF) 88.1%)"
        w="100%"
        overflow="hidden"
      >
        <Text size="sm">
          Hãy chọn tổng kích thước của các gói hàng để Ahamove sắp xếp tài xế và
          xe phù hợp cho bạn.
        </Text>
      </Card>

      <Box style={{ flex: 1 }}>
        <Swiper
          style={{
            overflow: 'visible',
            height: 'auto',
            position: 'relative',
            padding: isMobile ? '0 16px' : '0 24px',
          }}
          spaceBetween={8}
          slidesPerView={1.3}
          className="mb-6"
          mousewheel={true}
          onSlideChange={handleSlideChange}
          modules={[Mousewheel]}
          cssMode={true}
          // centeredSlides={true}
        >
          <Box ml={16} mb={16}>
            {sizeDefinitionList?.length > 0
              ? sizeDefinitionList.map((item, i) => {
                  return (
                    <SwiperSlide key={item.size}>
                      <Card
                        w="100%"
                        radius={12}
                        h="100%"
                        p="xs"
                        display="flex"
                        pos="relative"
                        withBorder
                        style={{
                          borderColor:
                            activeIndex === i
                              ? 'var(--mantine-color-primary-6)'
                              : 'var(--mantine-color-neutral-3)',
                        }}
                        className="w-full p-4"
                      >
                        <Title c="neutral.7" fw={600} order={5}>
                          Size {item.size}
                        </Title>
                        <Text c="neutral.6" size="sm">
                          {item.description}
                        </Text>

                        <Image
                          src={item.image_url}
                          alt={item.size}
                          w="100%"
                          h={144}
                        />
                      </Card>
                    </SwiperSlide>
                  );
                })
              : null}
          </Box>

          <SwiperNavigation />
        </Swiper>

        {activeIndex === 5 ? (
          <Card
            m={24}
            p={12}
            radius={rem(4)}
            style={{
              background: 'var(--mantine-color-secondary-0)',
            }}
          >
            <Group wrap="nowrap" gap={8}>
              <IconInfo className="size-6" />
              <Title order={6} c="neutral.7">
                Hàng hóa kích thước lớn phù hợp để giao hàng bằng Xe Tải.
              </Title>
            </Group>
          </Card>
        ) : null}
      </Box>

      <SimpleGrid
        p={24}
        w="100%"
        cols={1}
        spacing="md"
        style={{
          marginTop: isMobile ? 'auto' : undefined,
          position: isMobile ? 'sticky' : 'relative',
          bottom: isMobile ? 0 : undefined,
          backgroundColor: 'white',
        }}
      >
        <Button
          fullWidth
          c={'secondary.7'}
          variant={'light'}
          color={'neutral'}
          mih={rem(48)}
          radius={rem(4)}
          fw={700}
          onClick={handleClose}
        >
          {tCommon('got_it')}
        </Button>
      </SimpleGrid>
    </Box>
  );
};

export default BikePackageSizeDefinitionModal;
